import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';

var TCaptchaNetworkingError;

(function (TCaptchaNetworkingError) {
  TCaptchaNetworkingError["InvalidContentType"] = "Invalid_Content_Type";
  TCaptchaNetworkingError["NetworkingError"] = "NetworkingError";
})(TCaptchaNetworkingError || (TCaptchaNetworkingError = {}));

var delay = function delay(ms) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Promise(function (resolve) {
    return setTimeout(function () {
      return resolve(data);
    }, ms);
  });
};
function getUrlParam(name) {
  var reg = new RegExp("(\\?|&)".concat(name, "=([^&#]*)(&|#|$)")); // 构造一个含有目标参数的正则表达式对象

  var search = window.location.href;
  var r = search.match(reg); // 匹配目标参数

  if (r != null) return decodeURI(r[2]);
  return null; // 返回参数值
} //

var buildCoupeUri = function buildCoupeUri(id) {
  var env = getUrlParam('act_coupe_env');

  if (env) {
    return "https://coupe-api.xlcx.work/schema/".concat(env, "/").concat(id, "_data.json");
  } else {
    return "https://coupe-static.xiaolachuxing.com/schema/".concat(id, "_data.json");
  }
};
var parseUserType = function parseUserType() {
  var u = getUrlParam('u');

  if (u) {
    return String(u);
  } // 默认是 用户


  return '1';
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var buildGateway = function buildGateway(env, host) {
  if (['stg', 'pre'].includes(env)) {
    return "https://hestia-".concat(env, ".").concat(host);
  }

  return "https://hestia.".concat(host);
};

var hestiaRequest = function hestiaRequest() {
  var _window$__captcha__co;

  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'GET';
  var endpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/hello';
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var extraHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var _ref = (_window$__captcha__co = window.__captcha__config__) !== null && _window$__captcha__co !== void 0 ? _window$__captcha__co : {},
      host = _ref.host,
      env = _ref.env;

  var baseUrl = buildGateway(env, host);
  var url = baseUrl + endpoint;

  var headers = _objectSpread({
    'Content-Type': 'application/json',
    'X-User-Businessline': '8',
    'X-User-Type': parseUserType()
  }, extraHeaders);

  var options = {
    method: method,
    headers: headers
  };

  if (method === 'GET') {
    var queryString = "".concat(Object.keys(params).map(function (k) {
      return [k, params[k]].map(encodeURIComponent).join('=');
    }).join('&'));
    if (queryString) url += "?".concat(queryString);
  } else if (method === 'POST' || method === 'PUT') {
    if (headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      options.body = "".concat(Object.keys(params).map(function (k) {
        var val = params[k];

        if (Object.prototype.toString.call(val) === '[object Object]') {
          val = JSON.stringify(val);
        }

        return [k, val].join('=');
      }).join('&'));
    } else if (headers['Content-Type'] === 'multipart/form-data') {
      // @ts-ignore
      delete headers['Content-Type'];
      var formData = new FormData();
      Object.keys(params).forEach(function (key) {
        return formData.append(key, params[key]);
      });
      options.body = formData;
    } else {
      options.body = JSON.stringify(params);
    }
  }

  return fetch(url, options).then(function (res) {
    if (!res.ok) {
      return Promise.reject({
        message: TCaptchaNetworkingError.NetworkingError
      });
    }

    var contentType = res.headers.get('content-type');

    if (/json/.test(contentType)) {
      return res.json().then(function (data) {
        if (Number(data === null || data === void 0 ? void 0 : data.ret) === 0) {
          return data === null || data === void 0 ? void 0 : data.data;
        } else {
          return Promise.reject(data);
        }
      });
    }

    return Promise.reject({
      message: TCaptchaNetworkingError.InvalidContentType
    });
  });
};
var verifyType = function verifyType() {
  return hestiaRequest('GET', '/act/passport/verify_type', {}, {
    'Content-Type': 'application/x-www-form-urlencoded'
  });
};
var geePassport = function geePassport(params) {
  return hestiaRequest('POST', '/act/passport/geetest', params, {
    'Content-Type': 'application/x-www-form-urlencoded'
  });
};

var loadedScripts = [];
var pendingScripts = [];
var loadScript = function loadScript(src) {
  var metas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var tryCount = 5;
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
      var script;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!pendingScripts.includes(src)) {
                _context.next = 11;
                break;
              }

            case 1:
              if (!(tryCount > 0)) {
                _context.next = 10;
                break;
              }

              if (!loadedScripts.includes(src)) {
                _context.next = 5;
                break;
              }

              resolve(true);
              return _context.abrupt("break", 10);

            case 5:
              _context.next = 7;
              return delay(100);

            case 7:
              tryCount--;
              _context.next = 1;
              break;

            case 10:
              reject('TRY_MANY_COUNT_ERROR');

            case 11:
              if (loadedScripts.includes(src)) {
                console.log('脚本已被加载过:', src);
                resolve(true);
              } else {
                pendingScripts.push(src);
                script = document.createElement('script');
                script.src = src;
                script.type = 'text/javascript';
                Object.keys(metas).forEach(function (key) {
                  script[key] = metas[key];
                }); // script.crossOrigin = 'anonymous';
                // blocked by CORS policy

                script.addEventListener('load', function () {
                  loadedScripts.push(src);
                  console.log('脚本加载成功:', loadedScripts);
                  var idx = pendingScripts.findIndex(function (str) {
                    return str === src;
                  });

                  if (idx >= 0) {
                    pendingScripts.splice(idx, 1);
                  }

                  resolve(true);
                });
                script.addEventListener('error', function (e) {
                  reject(e);
                });
                document.head.appendChild(script);
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

var CaptchaTypes;

(function (CaptchaTypes) {
  CaptchaTypes["geetest"] = "geetest";
  CaptchaTypes["netease"] = "netease";
  CaptchaTypes["nothing"] = "nothing";
})(CaptchaTypes || (CaptchaTypes = {}));

var AbstractCaptcha = /*#__PURE__*/function () {
  function AbstractCaptcha() {
    _classCallCheck(this, AbstractCaptcha);

    this.captchaIns = null;
    this.errorCb = null;
    this.verifyCb = null;
    this.loadCb = null;
  }

  _createClass(AbstractCaptcha, [{
    key: "onLoad",
    value: function onLoad(loadCb) {
      this.loadCb = loadCb;
      return this;
    } // eslint-disable-next-line @typescript-eslint/ban-types

  }, {
    key: "onError",
    value: function onError(errorCb) {
      this.errorCb = errorCb;
      return this;
    }
  }, {
    key: "onVerify",
    value: function onVerify(verifyCb) {
      this.verifyCb = verifyCb;
      return this;
    }
  }, {
    key: "refresh",
    value: function refresh() {
      if (this.captchaIns) {
        this.captchaIns.refresh();
      } else {
        throw new Error('No captchaIns, cannot refresh');
      }
    }
  }, {
    key: "verify",
    value: function verify() {
      if (this.captchaIns) {
        this.captchaIns.verify();
      } else {
        throw new Error('No captchaIns, cannot verify');
      }
    }
  }], [{
    key: "loadResource",
    value: function () {
      var _loadResource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return loadScript(url);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function loadResource(_x) {
        return _loadResource.apply(this, arguments);
      }

      return loadResource;
    }()
  }]);

  return AbstractCaptcha;
}();

var DEFAULT_CONFIG = {
  env: 'stg',
  backdoor: true,
  host: 'xiaolachuxing.com',
  netCaptchaId: '6038a527d0514eb899d055a75a5fee54',
  netMode: 'popup',
  netWidth: '320px',
  netApiVersion: 2,
  showErrorToast: false,
  popupStyles: {
    position: 'fixed',
    top: '20%'
  }
};

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var NetCaptcha = /*#__PURE__*/function (_AbstractCaptcha) {
  _inherits(NetCaptcha, _AbstractCaptcha);

  var _super = _createSuper$2(NetCaptcha);

  function NetCaptcha() {
    _classCallCheck(this, NetCaptcha);

    return _super.apply(this, arguments);
  }

  _createClass(NetCaptcha, [{
    key: "loadSDKInitConfig",
    value: function loadSDKInitConfig() {
      return Promise.resolve({});
    }
  }, {
    key: "init",
    value: function init() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      var self = this; // @ts-ignore

      return new Promise(function (resolve, reject) {
        var _window$__captcha__co, _window;

        var n = document.createElement('div');
        n.id = 'captcha_div';
        document.body.appendChild(n); // @ts-ignore
        // @ts-ignore

        var _ref = (_window$__captcha__co = (_window = window) === null || _window === void 0 ? void 0 : _window.__captcha__config__) !== null && _window$__captcha__co !== void 0 ? _window$__captcha__co : {},
            netCaptchaId = _ref.netCaptchaId,
            netWidth = _ref.netWidth;
            _ref.netMode;
            var netApiVersion = _ref.netApiVersion,
            popupStyles = _ref.popupStyles;

        window.initNECaptcha({
          element: '#captcha_div',
          captchaId: netCaptchaId || DEFAULT_CONFIG.netCaptchaId,
          width: netWidth || DEFAULT_CONFIG.netWidth,
          apiVersion: netApiVersion || DEFAULT_CONFIG.netApiVersion,
          popupStyles: popupStyles || DEFAULT_CONFIG.popupStyles,
          onVerify: function onVerify(err, data) {
            if (err) {
              if (self.errorCb) {
                self.errorCb({
                  type: CaptchaTypes.netease,
                  error: err
                });
              } else {
                reject(new Error('no error callback'));
              }

              return;
            }

            if (data) {
              if (self.verifyCb) {
                self.verifyCb({
                  type: CaptchaTypes.netease,
                  data: data
                });
              } else {
                reject(new Error('no verify callback'));
              }
            }
          }
        }, function (ins) {
          self.captchaIns = ins;

          if (self.loadCb) {
            self.loadCb();
          }

          resolve(undefined);
        }, function (err) {
          if (self.errorCb) {
            self.errorCb({
              type: CaptchaTypes.netease,
              error: err
            });
          }

          reject(err);
        });
      });
    }
  }, {
    key: "loadPresetScripts",
    value: function () {
      var _loadPresetScripts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('NetCaptcha loadPresetScripts...');
                _context.next = 3;
                return NetCaptcha.loadResource("https://cstaticdun.126.net/load.min.js?t=".concat(Date.now()));

              case 3:
                return _context.abrupt("return", null);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function loadPresetScripts() {
        return _loadPresetScripts.apply(this, arguments);
      }

      return loadPresetScripts;
    }() // @ts-ignore

  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('NetCaptcha execute...');
                _context2.next = 3;
                return delay(20);

              case 3:
                _context2.next = 5;
                return this.loadSDKInitConfig();

              case 5:
                _context2.next = 7;
                return delay(20);

              case 7:
                _context2.next = 9;
                return this.init();

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function execute() {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
  }]);

  return NetCaptcha;
}(AbstractCaptcha);

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var GeeCaptcha = /*#__PURE__*/function (_AbstractCaptcha) {
  _inherits(GeeCaptcha, _AbstractCaptcha);

  var _super = _createSuper$1(GeeCaptcha);

  function GeeCaptcha() {
    _classCallCheck(this, GeeCaptcha);

    return _super.apply(this, arguments);
  }

  _createClass(GeeCaptcha, [{
    key: "loadPresetScripts",
    value: function () {
      var _loadPresetScripts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('GeeCaptcha loadPresetScripts...');
                _context.next = 3;
                return GeeCaptcha.loadResource("https://static.huolala.cn/libs/gt/0.0.0/gt.js");

              case 3:
                return _context.abrupt("return", null);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function loadPresetScripts() {
        return _loadPresetScripts.apply(this, arguments);
      }

      return loadPresetScripts;
    }() // @ts-ignore

  }, {
    key: "loadSDKInitConfig",
    value: function () {
      var _loadSDKInitConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
        var phoneNo;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                phoneNo = _ref.phoneNo;
                _context2.next = 3;
                return geePassport({
                  phone_no: phoneNo
                });

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function loadSDKInitConfig(_x) {
        return _loadSDKInitConfig.apply(this, arguments);
      }

      return loadSDKInitConfig;
    }() // @ts-ignore

  }, {
    key: "init",
    value: function init(_ref2) {
      var gt = _ref2.gt,
          challenge = _ref2.challenge,
          new_captcha = _ref2.new_captcha,
          success = _ref2.success;
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      var self = this; // @ts-ignore

      window.initGeetest({
        gt: gt,
        challenge: challenge,
        new_captcha: new_captcha,
        product: 'bind',
        offline: !success // 表示用户后台检测极验服务器是否宕机，一般不需要关注

      }, function (captchaObj) {
        captchaObj.onReady(function () {
          console.log('geeCaptcha onReady...');
          self.captchaIns = captchaObj;

          if (self.loadCb) {
            self.loadCb({
              instance: self.captchaIns
            });
          }
        });
        captchaObj.onSuccess(function () {
          var result = captchaObj.getValidate();
          console.log('geeCaptcha onSuccess...', result);

          if (self.verifyCb) {
            self.verifyCb({
              type: CaptchaTypes.geetest,
              data: result
            });
          }
        });
        captchaObj.onError(function (err) {
          console.log('geeCaptcha onError...');

          if (self.errorCb) {
            self.errorCb({
              type: CaptchaTypes.geetest,
              error: err
            });
          }
        });
        captchaObj.onClose(function () {
          console.log('geeCaptcha onClose...');
        });
      });
    } // @ts-ignore

  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
        var phoneNo, _yield$this$loadSDKIn, gt, challenge, new_captcha, success;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                phoneNo = _ref3.phoneNo;
                console.log('GeeCaptcha execute...', phoneNo);
                _context3.next = 4;
                return delay(20);

              case 4:
                _context3.next = 6;
                return this.loadSDKInitConfig({
                  phoneNo: phoneNo
                });

              case 6:
                _yield$this$loadSDKIn = _context3.sent;
                gt = _yield$this$loadSDKIn.gt;
                challenge = _yield$this$loadSDKIn.challenge;
                new_captcha = _yield$this$loadSDKIn.new_captcha;
                success = _yield$this$loadSDKIn.success;
                _context3.next = 13;
                return delay(20);

              case 13:
                _context3.next = 15;
                return this.init({
                  gt: gt,
                  challenge: challenge,
                  new_captcha: new_captcha,
                  success: success
                });

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function execute(_x2) {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
  }]);

  return GeeCaptcha;
}(AbstractCaptcha);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var NoneCaptcha = /*#__PURE__*/function (_AbstractCaptcha) {
  _inherits(NoneCaptcha, _AbstractCaptcha);

  var _super = _createSuper(NoneCaptcha);

  function NoneCaptcha() {
    _classCallCheck(this, NoneCaptcha);

    return _super.apply(this, arguments);
  }

  _createClass(NoneCaptcha, [{
    key: "loadPresetScripts",
    value: function () {
      var _loadPresetScripts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function loadPresetScripts() {
        return _loadPresetScripts.apply(this, arguments);
      }

      return loadPresetScripts;
    }() // @ts-ignore

  }, {
    key: "loadSDKInitConfig",
    value: function () {
      var _loadSDKInitConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function loadSDKInitConfig() {
        return _loadSDKInitConfig.apply(this, arguments);
      }

      return loadSDKInitConfig;
    }()
  }, {
    key: "init",
    value: function init() {
      if (this.loadCb) {
        this.loadCb();
      }

      if (this.verifyCb) {
        this.verifyCb({
          type: CaptchaTypes.nothing,
          data: null
        });
      }

      return Promise.resolve();
    } // @ts-ignore

  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.loadSDKInitConfig();

              case 2:
                _context3.next = 4;
                return this.init();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function execute() {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
  }, {
    key: "verify",
    value: function verify() {
      if (this.captchaIns) {
        this.captchaIns.verify();
      }
    }
  }]);

  return NoneCaptcha;
}(AbstractCaptcha);

var CaptchaFactory = /*#__PURE__*/function () {
  function CaptchaFactory() {
    _classCallCheck(this, CaptchaFactory);

    this.type = null;
    this.ins = null;
    this.coupeId = 'b808bb3efeb241e0b469a024cac1ed05';
    this.config = null;
  }

  _createClass(CaptchaFactory, [{
    key: "createCaptcha",
    value: function () {
      var _createCaptcha = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.loadCoupeConfig();

              case 2:
                _context.next = 4;
                return this.fetchVerifyType();

              case 4:
                _context.next = 6;
                return this.createSpecficCaptcha();

              case 6:
                _context.next = 8;
                return this.ins.loadPresetScripts();

              case 8:
                return _context.abrupt("return", this.ins);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createCaptcha() {
        return _createCaptcha.apply(this, arguments);
      }

      return createCaptcha;
    }()
  }, {
    key: "getType",
    value: function getType() {
      return this.type;
    }
  }, {
    key: "loadCoupeConfig",
    value: function () {
      var _loadCoupeConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var info;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Promise.race([fetch(buildCoupeUri(this.coupeId)).then(function (r) {
                  return r.json();
                }).then(function (r) {
                  var _r$data;

                  var config = r === null || r === void 0 ? void 0 : (_r$data = r.data) === null || _r$data === void 0 ? void 0 : _r$data.config;
                  var res = {
                    orgin: 'coupe',
                    config: {}
                  };

                  try {
                    res.config = JSON.parse(config);
                  } catch (e) {
                    console.error('parse json error in captcha-sdk loadCoupeConfig', e);
                  }

                  return res;
                }), delay(2000, {
                  orgin: 'local',
                  config: DEFAULT_CONFIG
                })]);

              case 2:
                info = _context2.sent;
                this.config = info === null || info === void 0 ? void 0 : info.config;
                console.log("config load from ".concat(info === null || info === void 0 ? void 0 : info.orgin, ", values is: ").concat(JSON.stringify(this.config))); // 业务层可以使用这个全局变量

                window.__captcha__config__ = this.config;
                return _context2.abrupt("return", this.config);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadCoupeConfig() {
        return _loadCoupeConfig.apply(this, arguments);
      }

      return loadCoupeConfig;
    }()
  }, {
    key: "fetchVerifyType",
    value: function () {
      var _fetchVerifyType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this$config;

        var res, backdoorVerifyType;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return verifyType();

              case 2:
                res = _context3.sent;
                console.log('server config validate type is: ', res === null || res === void 0 ? void 0 : res.defaultType);
                backdoorVerifyType = getUrlParam('act_verify_type');

                if ((_this$config = this.config) !== null && _this$config !== void 0 && _this$config.backdoor && backdoorVerifyType) {
                  console.log('backdoor config validate type is: ', backdoorVerifyType);
                  this.type = backdoorVerifyType;
                } else {
                  // this.type = res?.defaultType;
                  // this.type = CaptchaTypes.nothing;
                  console.log('remote server config validate type is: ', res === null || res === void 0 ? void 0 : res.defaultType);
                  this.type = res === null || res === void 0 ? void 0 : res.defaultType;
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchVerifyType() {
        return _fetchVerifyType.apply(this, arguments);
      }

      return fetchVerifyType;
    }()
  }, {
    key: "createSpecficCaptcha",
    value: function createSpecficCaptcha() {
      if (this.type === CaptchaTypes.netease) {
        this.ins = new NetCaptcha();
      } else if (this.type === CaptchaTypes.geetest) {
        this.ins = new GeeCaptcha();
      } else if (this.type === CaptchaTypes.nothing) {
        this.ins = new NoneCaptcha();
      }

      return this.ins;
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (CaptchaFactory.instance) {
        return CaptchaFactory.instance;
      } else {
        return CaptchaFactory.instance = new CaptchaFactory();
      }
    }
  }]);

  return CaptchaFactory;
}();

export { CaptchaFactory };
//# sourceMappingURL=index.js.map
